<!--
 - Order Tabs
 -
 - @version
 - 4.77.0 OAUI-725 Implement custom tab for list orders page
 - 4.71.0 OAUI-694 Final UI tweaks and finishing touches
 - 4.71.0 OAUI-685 Implement tabbed sections on table
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2024 Build Centrix
 -->
<div class="bcx-table-tabs">
  <ul
    class="nav nav-tabs"
    [ngClass]="{ 'no-select': !this.wdEnvironmentService.permissions.canChangeOrderStatus }"
  >
    <li class="nav-item" *ngFor="let tab of wdOrdersService.tabbedOrderContent">
      <a
        *ngIf="tab.isVisible"
        class="nav-link"
        [ngClass]="{ active: tab.key === wdOrdersService.orderViewSettings?.selectedTab?.key }"
        [routerLink]="['./']"
        [queryParams]="{ tab: tab.key }"
        (click)="wdOrdersService.initColumnToggleOptions(orderType, tab.key)"
      >
        <bc-atoms-icon [type]="tab.iconKey"></bc-atoms-icon>
        <span class="ml-2 mr-2">{{ tab.label }}</span>
      </a>
    </li>
  </ul>
</div>
